/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdAdditionalData202,
  PutApiV1PersonIdAdditionalData400,
  PutApiV1PersonIdAdditionalData401,
  PutApiV1PersonIdAdditionalData404,
  PutApiV1PersonIdAdditionalData500,
  PutApiV1PersonIdAdditionalDataMutationRequest,
  PutApiV1PersonIdAdditionalDataMutationResponse,
  PutApiV1PersonIdAdditionalDataPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdAdditionalData.ts";
import { personAdditionalDataViewModelSchema } from "../personAdditionalDataViewModelSchema.ts";
import { updateAdditionalDataRequestSchema } from "../updateAdditionalDataRequestSchema.ts";

export const putApiV1PersonIdAdditionalDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdAdditionalDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdAdditionalData202Schema = z.lazy(
  () => personAdditionalDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdAdditionalData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdAdditionalData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAdditionalData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdAdditionalData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAdditionalData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdAdditionalData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAdditionalData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdAdditionalData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAdditionalData500>;

export const putApiV1PersonIdAdditionalDataMutationRequestSchema = z.lazy(
  () => updateAdditionalDataRequestSchema,
) as unknown as ToZod<PutApiV1PersonIdAdditionalDataMutationRequest>;

export const putApiV1PersonIdAdditionalDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdAdditionalData202Schema,
) as unknown as ToZod<PutApiV1PersonIdAdditionalDataMutationResponse>;
